import { SourceInput } from "@/components/studio/SourceInput";

const METHOD = [
  "Acquisisci il testo da libro, file o web.",
  "Rivedi e correggi il testo estratto.",
  "L'AI crea una mappa visiva con simboli e colori.",
  "Scarica il PDF o salvalo nel tuo archivio.",
];

export const StepSource = ({ onExtracted }) => (
  <div className="grid lg:grid-cols-12 gap-8">
    <section className="lg:col-span-8 bg-white border border-zinc-200 p-6 lg:p-8 rise">
      <h2 className="font-display text-2xl font-bold tracking-tight mb-1">Fase 01 — Inserisci il materiale</h2>
      <p className="text-sm text-zinc-600 mb-6">Scansiona una pagina, carica un file o incolla un link.</p>
      <SourceInput onExtracted={onExtracted} />
    </section>
    <aside className="lg:col-span-4 border border-zinc-200 bg-zinc-50 p-6 lg:p-8 space-y-6">
      <p className="text-xs font-semibold uppercase tracking-wider text-zinc-600">Il metodo in 4 fasi</p>
      {METHOD.map((t, i) => (
        <div key={t} className="flex gap-4">
          <span className="font-display text-3xl font-extrabold text-zinc-300 leading-none">0{i + 1}</span>
          <p className="text-sm text-zinc-700 pt-1">{t}</p>
        </div>
      ))}
    </aside>
  </div>
);
